module.exports = __webpack_public_path__ + "img/3MLogo.69c4012c.svg";